import { TextFieldProps } from '@mui/material';
import { useState } from 'react';
import { StyledTextInput } from './TextInput.styles';

export function TextInput(props: TextFieldProps): JSX.Element {
  const [innerValue, setValue] = useState(props.value);
  return (
    <StyledTextInput
      {...props}
      value={innerValue}
      onChange={(event) => {
        setValue(event.target.value);
        props?.onChange?.(event);
      }}
    />
  );
}
